import React from 'react';

const BANNER_SKELETON_TYPES = [
  'banner-simple-ancho-total',
  'destacado-2-lugares-75-25',
  '2-banner-ancho-total',
  'banner-zocalo-x3',
  'carrusel-3-elementos',
  'carrusel-4-elementos',
  'galeria-ofertas',
  'banner-hover-x4',
  'video',
];

const SectionTitleSkeleton = () => <div className='mb-3 h-6 w-56 rounded-full bg-gray-200' />;

const BannerCardSkeleton = ({ className = '' }) => (
  <div className={`overflow-hidden rounded-2xl bg-white shadow-sm ${className}`}>
    <div className='h-full min-h-[220px] bg-gray-200 md:min-h-[300px] lg:min-h-[360px]' />
    <div className='space-y-2 p-3'>
      <div className='h-4 w-2/3 rounded-full bg-gray-100' />
      <div className='h-3 w-1/2 rounded-full bg-gray-100' />
    </div>
  </div>
);

const BannerSectionSkeleton = ({ children, withTitle = true }) => (
  <div className='container mb-8 md:mb-12'>
    {withTitle && <SectionTitleSkeleton />}
    {children}
  </div>
);

const BannerSkeletonByType = ({ type }) => {
  if (type === 'video') {
    return (
      <BannerSectionSkeleton>
        <div className='rounded-xl bg-gray-100 p-3'>
          <div className='relative h-64 rounded-xl bg-gray-200 md:h-[450px]'>
            <div className='absolute left-1/2 top-1/2 h-16 w-16 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white/70' />
            <div className='absolute left-1/2 top-1/2 h-0 w-0 -translate-x-[35%] -translate-y-1/2 border-y-[12px] border-l-[18px] border-y-transparent border-l-gray-300' />
          </div>
        </div>
      </BannerSectionSkeleton>
    );
  }

  if (type === 'destacado-2-lugares-75-25') {
    return (
      <BannerSectionSkeleton>
        <div className='grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3'>
          <BannerCardSkeleton className='md:col-span-1 lg:col-span-2' />
          <BannerCardSkeleton />
        </div>
      </BannerSectionSkeleton>
    );
  }

  if (type === '2-banner-ancho-total') {
    return (
      <BannerSectionSkeleton>
        <div className='grid grid-cols-1 gap-5 md:grid-cols-2'>
          <BannerCardSkeleton />
          <BannerCardSkeleton />
        </div>
      </BannerSectionSkeleton>
    );
  }

  if (type === 'banner-zocalo-x3') {
    return (
      <BannerSectionSkeleton withTitle={false}>
        <div className='grid grid-cols-1 gap-5 md:grid-cols-3'>
          {Array.from({ length: 3 }).map((_, index) => (
            <div
              key={`${type}-${index}`}
              className={`${index > 0 ? 'hidden md:block' : ''} h-[400px] rounded bg-gray-100 sm:h-[500px] md:h-[217px] lg:h-[250px] xl:h-[400px]`}
            />
          ))}
        </div>
      </BannerSectionSkeleton>
    );
  }

  if (type === 'carrusel-3-elementos' || type === 'carrusel-4-elementos') {
    const items = type === 'carrusel-4-elementos' ? 4 : 3;
    const gridClass = type === 'carrusel-4-elementos' ? 'md:grid-cols-4' : 'md:grid-cols-3';

    return (
      <BannerSectionSkeleton>
        <div className={`grid grid-cols-1 gap-5 ${gridClass}`}>
          {Array.from({ length: items }).map((_, index) => (
            <BannerCardSkeleton key={`${type}-${index}`} className={index > 0 ? 'hidden md:block' : ''} />
          ))}
        </div>
      </BannerSectionSkeleton>
    );
  }

  if (type === 'galeria-ofertas') {
    return (
      <BannerSectionSkeleton>
        <div className='grid grid-cols-1 gap-5 md:grid-cols-3'>
          <BannerCardSkeleton />
          <BannerCardSkeleton className='hidden md:block' />
          <BannerCardSkeleton className='hidden md:block' />
        </div>
      </BannerSectionSkeleton>
    );
  }

  if (type === 'banner-hover-x4') {
    return (
      <BannerSectionSkeleton>
        <div className='flex flex-wrap justify-center gap-5'>
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={`${type}-${index}`} className='h-80 w-full rounded-2xl bg-gray-100 shadow-sm sm:w-[calc(50%_-_0.625rem)] lg:w-[calc(25%_-_0.9375rem)]' />
          ))}
        </div>
      </BannerSectionSkeleton>
    );
  }

  return (
    <BannerSectionSkeleton>
      <div className='h-64 rounded-xl bg-gray-200 md:h-80 lg:h-96' />
    </BannerSectionSkeleton>
  );
};

export const LoadingBannersState = () => (
  <div className='flex flex-col gap-6 animate-pulse'>
    {BANNER_SKELETON_TYPES.map((type) => (
      <BannerSkeletonByType key={type} type={type} />
    ))}
  </div>
);
